module.exports = "./assets/assets/代理协议模板.871d05aa.docx";